module.exports = __webpack_public_path__ + "static/media/downArrow.33826a00.svg";